const SvgQuantum1 = (props) => (
  <>
    <defs />
    <path
      d="M288.37 96.37c0 26.61-10.79 50.71-28.23 68.15-14.77 14.77-39.88 24.79-61.69 27.5M185.38 191.48c-23.43-2.45-46.76-12.19-61.53-26.96-17.44-17.44-28.23-41.53-28.23-68.15"
      strokeWidth="3px"
      fill="none"
      stroke="#001d6c"
      strokeMiterlimit={10}
    />
    <path
      d="M123.85 28.23c-17.44 17.44-28.23 41.53-28.23 68.15M199.25.33c24.15 1.53 44.82 11.82 60.9 27.89 17.44 17.44 28.23 41.53 28.23 68.15M288.37 287.63c0 26.61-10.79 50.71-28.23 68.15M185.66 192.3c-21.81 2.71-47.03 12.41-61.8 27.19-17.44 17.44-28.23 41.53-28.23 68.15"
      strokeWidth="3px"
      fill="none"
      stroke="#001d6c"
      strokeMiterlimit={10}
    />
    <path
      d="M183.19 383.6c-23.1-2.09-43.84-12.34-59.33-27.83-17.44-17.44-28.23-41.53-28.23-68.15M288.37 287.63c0-26.61-10.79-50.71-28.23-68.15-14.77-14.77-38.79-24.47-60.6-27.19M287.62 288.38c-24.66 0-49.33-9.41-68.15-28.23-15.75-15.75-24.72-40.25-27.28-60.77M287.62 95.62c-24.66 0-49.33 9.41-68.15 28.23-15.75 15.75-24.99 40.02-27.55 60.54M287.62 95.62c24.66 0 49.33 9.41 68.15 28.23 16.72 16.72 26.01 38.06 27.88 59.91M355.77 260.15c-18.82 18.82-43.48 28.23-68.15 28.23M191.65 184.12c-2.18-22.61-11.37-44.52-27.12-60.27-18.82-18.82-43.48-28.23-68.15-28.23"
      strokeWidth="3px"
      fill="none"
      stroke="#001d6c"
      strokeMiterlimit={10}
    />
    <path
      d="M28.23 123.85c18.82-18.82 43.48-28.23 68.15-28.23M96.38 288.38c-24.66 0-49.33-9.41-68.15-28.23C11.67 243.59 2.39 222.5.41 200.87"
      strokeWidth="3px"
      fill="none"
      stroke="#001d6c"
      strokeMiterlimit={10}
    />
    <path
      d="M192.19 199.65c-2.57 20.52-11.91 44.74-27.67 60.5-18.82 18.82-43.48 28.23-68.15 28.23"
      strokeWidth="3px"
      fill="none"
      stroke="#001d6c"
      strokeMiterlimit={10}
    />
    <circle cx={192} r={8} strokeWidth="3px" fill="none" stroke="#001d6c" strokeMiterlimit={10} />
    <circle cx={192} cy={192} r={8} fill="#0062ff" strokeWidth={0} />
    <circle cx={192} cy={192} r={24} fill="none" stroke="#001d6c" strokeMiterlimit={10} />
    <circle cx={192} cy={384} r={8} strokeWidth="3px" fill="none" stroke="#001d6c" strokeMiterlimit={10} />
    <circle cy={192} r={8} strokeWidth="3px" fill="none" stroke="#001d6c" strokeMiterlimit={10} />
    <circle cx={384} cy={192} r={8} strokeWidth="3px" fill="none" stroke="#001d6c" strokeMiterlimit={10} />
  </>
);

export default SvgQuantum1;
